
import { Component, Vue } from 'vue-property-decorator';
import { SessionManager } from "@/components/utils/utils";

import {getBceidRegisterUrl} from "./BCeID_URLs"

import { namespace } from "vuex-class";   
import "@/store/modules/common";
const commonState = namespace("Common");

@Component
export default class LandingPage extends Vue {
    
    @commonState.State
    public userId!: string;

    isLoggedIn = false;
    pageReady = false;
    safetyInst = false;
      
    async mounted() {
        this.pageReady = false;
        this.safetyInst = false;
        //console.log(process)
        await SessionManager.getUserInfo(this.$store);
        if(this.userId){
            this.isLoggedIn = true
            this.$router.push({ name: "dashboard" });
        }else{
            this.isLoggedIn = false;
            this.pageReady = true;
        } 
    }
  
    public navigate(userType) {
        if(userType == 'new'){
            window.location.replace(getBceidRegisterUrl());
        }else{
           this.$router.push({ name: "dashboard" }); 
        }           
    }
  
}
